/**
 * Tooltip - Radix UI basierte Tooltip-Komponente (shadcn-style)
 *
 * P0 UX: Konsistente Tooltips im gesamten UI
 *
 * Features:
 * - Hover + Focus Trigger (Radix built-in)
 * - Keyboard accessible
 * - Animiert
 * - Accessible (aria)
 */

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

interface TooltipProps {
  content: string | ReactNode;
  children: ReactNode;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
  maxWidth?: number;
}

export function Tooltip({
  content,
  children,
  className = '',
  side = 'top',
  delayDuration = 200,
  maxWidth = 280,
}: TooltipProps) {
  if (!content) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild className={className}>
          <span className="inline-flex cursor-default">{children}</span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={4}
            className="
              z-50 overflow-hidden rounded-md 
              bg-grund px-3 py-2 text-xs text-tinte leading-relaxed
              shadow-md
              animate-in fade-in-0 zoom-in-95
              data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
              data-[side=bottom]:slide-in-from-top-2
              data-[side=left]:slide-in-from-right-2
              data-[side=right]:slide-in-from-left-2
              data-[side=top]:slide-in-from-bottom-2
            "
            style={{ maxWidth }}
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-flaeche" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
